import { MeasuredCookie } from '../../Measured/redux/MeasuredCookie';
import { MeasuredCookieType } from '../../Measured';
export function setPwaCookie() {
    if (window.matchMedia &&
        window.matchMedia('(display-mode: standalone)').matches) {
        MeasuredCookie.write(MeasuredCookieType.HACK_FOR_PWA_FLAG, 1);
    }
    else {
        MeasuredCookie.write(MeasuredCookieType.HACK_FOR_PWA_FLAG, 0);
    }
}
//# sourceMappingURL=setPwaCookie.js.map